import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import "./SurveyPage.css";

function SurveyPage() {
  const { TicketNumber } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sig = queryParams.get("sig");

  const [answers, setAnswers] = useState({ Q1: 0, Q2: 0, Q3: 0 });
  const [message, setMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [alreadySubmitted, setAlreadySubmitted] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [errorReason, setErrorReason] = useState("");

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await axios.get("/survey/verify", {
          params: { ticket_id: TicketNumber, sig }
        });

        if (res.data.valid) {
          setIsValid(true);
        } else {
          setIsValid(false);
          setErrorReason(res.data.reason);
        }
      } catch (err) {
        console.error("Verification error", err);
        setIsValid(false);

        if (err.response && err.response.data && err.response.data.reason) {
          setErrorReason(err.response.data.reason); 
        } else {
          setErrorReason("server_error"); 
        }
      }

    };

    if (TicketNumber && sig) verify();
    else {
      setIsValid(false);
      setErrorReason("missing_params");
    }
  }, [TicketNumber, sig]);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await axios.get("/survey/check", {
          params: { ticket_id: TicketNumber }
        });
        setAlreadySubmitted(res.data.submitted);
      } catch (err) {
        console.error("Check error", err);
        setMessage("❌ Failed to check submission status.");
      }
    };

    if (TicketNumber) check();
  }, [TicketNumber]);

  const handleStarClick = (q, val) => setAnswers({ ...answers, [q]: val });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitted) return;

    try {
      await axios.post("/survey", {
        TicketNumber,
        sig,
        ...answers,
      });
      setMessage("✅ Thank you for your feedback!");
      setIsSubmitted(true);
    } catch (err) {
      if (err.response?.status === 403) {
        setMessage("❌ Invalid survey link.");
      } else if (err.response?.status === 409) {
        setMessage("⚠️ Survey already submitted.");
        setAlreadySubmitted(true);
      } else {
        setMessage("❌ Submission failed. Please try again.");
      }
    }
  };

  const renderStars = (q, v) => (
    [1, 2, 3, 4, 5].map(i => (
      <span
        key={i}
        className={`star ${v >= i ? "selected" : ""}`}
        onClick={() => handleStarClick(q, i)}
      >
        ★
      </span>
    ))
  );

  const isFormComplete = Object.values(answers).every(v => v > 0);

  if (isValid === false) {
    const errors = {
      ticket_not_found: "❌ Survey not Available.",
      invalid_signature: "❌ Survey not Available.",
      ticket_not_closed: "❌  Survey not Available.",
      missing_params: "❌  Survey not Available.",
      server_error: "❌ Survey not Available."
    };
    return <div className="survey-container"><h1>{errors[errorReason] || "❌ Survey not available."}</h1></div>;
  }

  if (isValid === null || alreadySubmitted === null) {
    return <div className="survey-container">🔄 Loading...</div>;
  }

  if (alreadySubmitted) {
    return (
      <div className="survey-container">
        <h1>📌 Survey already submitted</h1>
        <p>Thank you for your feedback!</p>
      </div>
    );
  }

  return (
    <div className="survey-container">
      <h1 className="survey-title">Customer Satisfaction Survey</h1>
      <p className="survey-description">Please rate our service by clicking stars below:</p>
      {message && <p className="survey-message">{message}</p>}
      {!isFormComplete && !isSubmitted && (
        <p className="survey-warning">⚠️ Please rate all 3 questions before submitting.</p>
      )}
      <form onSubmit={handleSubmit} className="survey-form">
        <div className="survey-question">
          <label>Question 1: การบริการ</label>
          <div className="star-rating">{renderStars("Q1", answers.Q1)}</div>
        </div>
        <div className="survey-question">
          <label>Question 2: ความรวดเร็ว</label>
          <div className="star-rating">{renderStars("Q2", answers.Q2)}</div>
        </div>
        <div className="survey-question">
          <label>Question 3: ความพึงพอใจ</label>
          <div className="star-rating">{renderStars("Q3", answers.Q3)}</div>
        </div>
        <button type="submit" className="survey-submit" disabled={!isFormComplete || isSubmitted}>
          Submit
        </button>
      </form>
    </div>
  );
}

export default SurveyPage;
